import React from 'react';
import PropTypes from 'prop-types';
import IframeResizer from 'iframe-resizer-react';
import { useStringTemplate } from '@blaze-cms/utils-handlebars';
import { IFRAME_CLASS, DEFAULT_WIDTH } from './constants';

const UNSAFE_URL_PATTERN = /^(javascript|data):/i;

const isSafeUrl = url => !UNSAFE_URL_PATTERN.test(url.trim());

const Iframe = ({ src, modifier, width, height, enableScrolling, parent }) => {
  const {
    data: [resolvedSrc]
  } = useStringTemplate(parent, [src || '']);
  if (!resolvedSrc || !isSafeUrl(resolvedSrc)) return null;
  const modifierString = modifier ? ` ${modifier}` : '';
  const iframeClassName = `${IFRAME_CLASS}${modifierString}`;
  const defaultWidth = !width ? DEFAULT_WIDTH : {};
  return (
    <div className={iframeClassName}>
      <IframeResizer
        scrolling={enableScrolling}
        autoResize
        src={resolvedSrc}
        sizeHeight={!height}
        height={height}
        width={width}
        style={defaultWidth}
      />
    </div>
  );
};

Iframe.propTypes = {
  src: PropTypes.string,
  enableScrolling: PropTypes.bool,
  modifier: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  parent: PropTypes.object
};

Iframe.defaultProps = {
  src: '',
  enableScrolling: false,
  modifier: '',
  width: '',
  height: '',
  parent: {}
};

export default Iframe;
